<template>
    <div class="bg-grey">

        <!-- HEADER -->
        <div class="header-top bg-white">
            <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                <div class="header-top--left">
                    <div class="header-item" @click="dashboard">
                        <img src="../../assets/icons/back-blue.svg" alt="a">
                    </div>
                </div>
                <div class="header-top--middle f-cont f-16 f-bold">{{label}}</div>
                <div class="header-top--right">
                    <div class="header-item"></div>
                </div>
            </div>
        </div>

        <!-- CONTENT -->
        <div class="content-wrapper main-page">

            <div class="w-limit">
                <div class="ph-item" style="padding:0px !important;height:calc(100vh - 115px) !important;">
                    <div class="ph-picture" style="height:650px;bottom:10px;"></div>
                </div>
                <iframe :src="iframe.src" class="iframeLoad" type="application/pdf" width="100%" frameborder="0" style="position:relative;bottom:0px;height:calc(100vh - 115px);width:100%" ref="frame" @load="load"
                        v-show="iframe.loaded">
                </iframe>
            </div>


        </div>

    </div>

</template>

<script>
    export default {
        name: "Ibos",
        data() {
            return {
                label: this.$route.query.label,
                iframe: {
                    src: this.iframeSrc() +
                        // src: "https://bos.smartlink.id/"+
                        // src: "https://localhost/"+
                        // src:"http://local.bos.smartlink.id/"+
                        this.$route.query.part +
                        '?smart_token=' +
                        localStorage.getItem('token'),
                    // src: 'https://bos.smartlink.id/profil?smart_token='+localStorage.getItem('token'), //DIV HERE #EDITOR
                    //src: 'http://local.bos.smartlink.id/profil',///profil?smart_token='+localStorage.getItem('token'), //DIV HERE #EDITOR
                    loaded: true
                }
            }
        },
        mounted() {
			this.addFlutterConfig()
			this.iframe.src += `&${this.$route.query.params}`
            // window.onpopstate = function(event) {
            //     alert(event);
            // }
            $(".iframeLoad").hide()
            window.addEventListener('message', this.recieveMessage);
        },
        beforeDestroy() {
            window.removeEventListener('message', this.recieveMessage);
        },
        watch: {
            '$route' (route, oldroute) {
            	var urlBos = route.query.part
	            var params = route.query.params
	            if (route.query.part === undefined) {
		            const url = new URL(window.location.href);
		            url.searchParams.set('part', oldroute.query.part);
                url.searchParams.set('params', oldroute.query.params);
		            url.searchParams.set('label', oldroute.query.label);
		            window.history.replaceState(null, null, url);
		            
		            urlBos = oldroute.query.part
		            params = oldroute.query.params
	            }
                this.iframe = {
                    src: this.iframeSrc() +
                        urlBos +
                        '?smart_token=' +
                        localStorage.getItem('token') + '&' + params,
                    loaded: true
                }
            }
        },
        methods: {
            recieveMessage(event) {
                if (event.data.type == 'download') {
                    this.download(event.data.url)
                }
            },
            download(url) {
                const flutterConfig = JSON.parse(localStorage.getItem('flutterConfig'))
                if (this.isWebview() && flutterConfig.platform !== 'web') {
                    this.flutterDownload(url);
               } else {
				    window.open(url, '_blank');
			   }
            },
            load: function () {
                $(".ph-item").hide()
                $(".iframeLoad").show()
                this.iframe.loaded = true;
            },
            dashboard() {
                this.$router.go(-2)

            },
            menu() {
                this.$router.push('/detailakunowner')
            },

            toggleMenu() {
                $("#nav-bottom").toggleClass("is-open");
            },
			addFlutterConfig(){
				const flutterConfig = JSON.parse(localStorage.getItem('flutterConfig'))
				if (flutterConfig) {
					const queryString = new URLSearchParams({
						api_base: flutterConfig.apiBase,
						platform: flutterConfig.platform,
						web_base: flutterConfig.webBase,
						user_type: flutterConfig.userType,
						idkaryawan: flutterConfig.idKaryawan,
						is_webview: flutterConfig.isWebview,
						idowner: localStorage.getItem('idowner'),
						wl: flutterConfig.wl,
					}).toString();
					this.iframe.src	+= `&${queryString}`
				}
			},

        }

    }

    // alert($(".nav-bottom--inner").outerHeight())

</script>
